// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"12":"baea069e","434":"1a8d7173","797":"73dfce8d","995":"1a2905d3"}[chunkId] + ".css";
};